import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { DayPickerPopover } from 'components/molecules/DayPickerPopover';
import { DateInput } from 'components/atoms/DateInput';

interface SingleDatePickerFormWrapperProps {
  date: Date | null;
  initialVisibleMonth: () => Date;
  isOutsideRange: (date: Date) => boolean;
  onChange: (date: Date) => void;
  onNextMonthClick: (date: Date) => void;
  onPrevMonthClick: (date: Date) => void;
  isCalendarLoading?: boolean;
}

const HostExperienceSingleDatePicker = ({
  date,
  initialVisibleMonth,
  isOutsideRange,
  onChange,
  onNextMonthClick,
  onPrevMonthClick,
  isCalendarLoading,
}: SingleDatePickerFormWrapperProps) => {
  const { t: translate } = useTranslation();

  const getActiveDate = useCallback(
    (date: Date | null) => {
      if (!date || (!isCalendarLoading && isOutsideRange(date))) {
        return undefined;
      }
      return date;
    },
    [isOutsideRange],
  );

  return (
    <DayPickerPopover
      isLoading={isCalendarLoading}
      mode="single"
      required
      animate
      defaultMonth={initialVisibleMonth()}
      selected={getActiveDate(date)}
      onSelect={onChange}
      modifiers={{
        disabled: isOutsideRange,
      }}
      onNextClick={onNextMonthClick}
      onPrevClick={onPrevMonthClick}
      asChild
      trigger={
        <DateInput
          date={getActiveDate(date) || new Date()}
          id="start-date-input"
          dateFormat="MMM D"
          placeholder={translate('date')}
        />
      }
      sideOffset={10}
      portalled
      footer={null}
    />
  );
};

export default HostExperienceSingleDatePicker;
